import { gql } from 'apollo-angular';
// migrated 1:1 from @nexato/nx-core-module (#682)
import { IssueType } from '../../../entities/issue/issue-type';
import { Page } from '../../../entities/page/page';


export const ISSUETYPES_QUERY = gql`
query issueTypesQuery($pageNumber: Int, $pageSize: Int, $sortProperty: String, $sortDirection: String)
{
  issueTypes: getIssueTypesPaged(
    filter: {
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection}
    })
    {
      totalPages
      totalElements
      number
      size
      content{
        code
        name
        prefix
        icon
        color
        isSystem
        isActive
      }
  }
}
`;

export interface IssueTypesQueryResponse {
  loading: boolean;
  issueTypes: Page<IssueType>;
}
